<template>
  <div>
    <v-dialog
      max-width="800"
      persistent
      transition="dialog-bottom-transition"
      v-model="showDialog"
    >
      <v-card :loading="loading">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Update License</v-toolbar-title>
        </v-toolbar>
        <v-form ref="form">
          <v-card flat>
            <v-card-title>
              Upload File
            </v-card-title>
            <v-card-text>
              <v-file-input
                v-model="file"
                show-size
                counter
                label="File input"
              ></v-file-input>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>
          <v-card flat>
            <v-card-title>
              Run Options
            </v-card-title>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="3">
                  <v-radio-group v-model="scheduleOrNow" :mandatory="true">
                    <v-radio label="Run now" value="now"></v-radio>
                    <v-radio label="Schedule" value="schedule"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="9">
                  <CloudWatchCronExpressionBuilder
                    v-model="scheduleExpression"
                    v-if="schedule"
                    show-next-events="5"
                  >
                  </CloudWatchCronExpressionBuilder>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card-text>
            {{ message }}
          </v-card-text>
          <v-card-actions>
            <v-btn @click="runOperation()">Run</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  SCHEDULE_UPDATE_LICENSE,
  UPDATE_LICENSE
} from '@/domain/showcases/constants/query'
import { GENERATE_PRESIGNED_POST } from '@/components/forms/query'
import CloudWatchCronExpressionBuilder from '@/components/CWCronExpressionBuilder/CloudWatchCronExpressionBuilder'
import { isScheduleOnceType } from '@/domain/showcases/util/schedule'

export default {
  name: 'ShowcaseOperationsExecution',
  components: {
    CloudWatchCronExpressionBuilder
  },
  data: () => ({
    showDialog: true,
    loading: false,
    scheduleOrNow: 'now',
    scheduleExpression: '',
    message: null,
    file: null
  }),
  props: ['showcase'],
  computed: {
    schedule: function() {
      return this.scheduleOrNow === 'schedule'
    },
    prefix: function() {
      return this.showcase.showcaseId
    }
  },
  methods: {
    runOperation() {
      this.loading = true
      this.message = 'Upload in progress'
      this.uploadFile(this.file, {}).then(result => {
        if (result.success) {
          let operationHandler =
            this.scheduleOrNow === 'now'
              ? this.operationHandler
              : this.scheduleOperationHandler
          this.message = 'Starting Operation'
          operationHandler(result)
            .then(response => {
              this.loading = false
              this.message = 'Success!'
              this.closeDialog()
            })
            .catch(err => {
              this.loading = false
              this.message = err
            })
        } else {
          this.loading = false
          this.message = result.message
        }
      })
    },
    async operationHandler(uploadResult) {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: UPDATE_LICENSE,
        variables: {
          showcaseId: this.showcase.showcaseId,
          licenseS3Key: uploadResult.message
        },
        fetchPolicy: 'no-cache'
      })
    },
    async scheduleOperationHandler(uploadResult) {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: SCHEDULE_UPDATE_LICENSE,
        variables: {
          showcaseId: this.showcase.showcaseId,
          licenseS3Key: uploadResult.message,
          scheduleExpression: 'cron(' + this.scheduleExpression + ')',
          scheduleType: isScheduleOnceType(this.scheduleExpression)
            ? 'ONCE'
            : 'PERIODIC'
        },
        fetchPolicy: 'no-cache'
      })
    },
    closeDialog() {
      this.$emit('close')
    },
    uploadFile: function(file, config) {
      return this.getSignedURL(file, null)
        .then(response => {
          return this.uploadToS3(response, file)
        })
        .catch(error => {
          this.message = error
          return error
        })
    },
    getSignedURL: async function(file, config) {
      return this.$apolloProvider.clients['SHOWCASE']
        .query({
          query: GENERATE_PRESIGNED_POST,
          variables: {
            prefix: this.prefix,
            key: file.name
          },
          fetchPolicy: 'network-only'
        })
        .then(response => {
          return {
            url: response.data.generatePresignedPost.url,
            fields: JSON.parse(response.data.generatePresignedPost.fields)
          }
        })
    },
    uploadToS3: function(response, file) {
      let fd = new FormData(),
        signature = response.fields

      Object.keys(signature).forEach(function(key) {
        fd.append(key, signature[key])
      })
      fd.append('file', file)
      return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest()
        request.open('POST', response.url, true)
        request.onload = function() {
          if (request.status === 204) {
            resolve({
              success: true,
              message: response.fields.key
            })
          } else {
            let s3Error = new window.DOMParser().parseFromString(
              request.response,
              'text/xml'
            )
            let errMsg = s3Error.firstChild.children[0].innerHTML
            reject({
              success: false,
              message:
                errMsg +
                '. Request is marked as resolved when returns as status 201'
            })
          }
        }
        request.onerror = function(err) {
          let s3Error = new window.DOMParser().parseFromString(
            request.response,
            'text/xml'
          )
          let errMsg = s3Error.firstChild.children[1].innerHTML
          reject({
            success: false,
            message: errMsg
          })
        }
        request.send(fd)
      })
    }
  }
}
</script>

<style scoped></style>
